import request from '@webtrader/core/request';

const authSession = () => {
  return request.patch<boolean>('/api/auth/v1/session');
};

export default authSession;
